import * as React from 'react';
import clsx from 'clsx';
import { formClasses } from './style';
const EMPTY_LIST = [];
function toErrorEntity(error, errorStatus, prefix, index) {
    return {
        key: typeof error === 'string' ? error : `${prefix}-${index}`,
        error,
        errorStatus,
    };
}
export default function ErrorList({ errors = EMPTY_LIST, className: rootClassName, fieldId, }) {
    const fullKeyList = React.useMemo(() => errors.map((error, index) => toErrorEntity(error, 'error', 'error', index)), [errors]);
    const helpProps = {};
    if (fieldId) {
        helpProps.id = `${fieldId}_errormessage`;
    }
    return (React.createElement("div", { ...helpProps, className: clsx(formClasses.item.explain, rootClassName), role: "alert" }, fullKeyList.map((item) => {
        const { key, error, errorStatus } = item;
        return (React.createElement("div", { key: key, className: clsx({
                [`${formClasses.item.explain}-${errorStatus}`]: errorStatus,
            }) }, error));
    })));
}
